import React from "react";
import * as Styles from "./styles/VehicleDetails";
import * as Form from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import * as FormsAem from "../common/styles/FormsAem";
import type { TradeInAemDetailFormItem } from "../../../utils/types";
import { useTradeInAemLabel } from "../../../utils/labels";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";

type Props = { formItem: TradeInAemDetailFormItem; formItemKey: string; showRequiredError?: boolean };

const VehicleDetailsCheckbox = ({ formItem, formItemKey, showRequiredError }: Props): JSX.Element => {
    const { label, options = [], value } = formItem;
    const csl = useTradeInCsl();
    const requiredLabel = useTradeInAemLabel("tradeInAemFieldRequired");

    return (
        <>
            <Styles.CheckboxGroup>
                <Styles.CheckboxGroupTitle>
                    {label}
                    {formItem.required && <FormsAem.MandatoryField largeFontSize>*</FormsAem.MandatoryField>}
                </Styles.CheckboxGroupTitle>
                {options.map((option) => (
                    <Form.Checkbox width={1} mt={0} key={option.value}>
                        <input
                            type="checkbox"
                            id={`${formItemKey}-${option.value}`}
                            checked={value.includes(option.value)}
                            onChange={(event) => {
                                const newValues = event.target.checked
                                    ? [...(value as string[]), option.value]
                                    : (value as string[]).filter((val) => val !== option.value);

                                csl.setFormItemValue(formItemKey, newValues);
                            }}
                        />
                        <label htmlFor={`${formItemKey}-${option.value}`}>{option.label}</label>
                    </Form.Checkbox>
                ))}
                {showRequiredError && formItem.required && formItem.value.length === 0 && (
                    <FormsAem.Error>
                        <span>{requiredLabel}</span>
                        <IconWrapper iconColor="primaryRed">
                            <IconExclamation />
                        </IconWrapper>
                    </FormsAem.Error>
                )}
            </Styles.CheckboxGroup>
        </>
    );
};

export default VehicleDetailsCheckbox;
